module.exports = __webpack_public_path__ + "media/images/payment/left-icon-8548a4d9204866ca46a347720d4f5945.png";